export default __webpack_public_path__ + "static/media/finwiserlogo.29c1126d5bebbe4c3f027621dedd750e.webp";